import { apiRequest } from "../../../framework/network/api-client";
import { ApiUrlPath as AUP } from "../../url-paths";
import { Id } from "../../../models/framework/db";
import { Category } from "../../../models/category";

export const categoryGet = async (body: {}, host?: string) =>
    await apiRequest<Array<Id<Category>>>(AUP.categoryGet, body, host);